import {useState} from "react";
import DeskFormState from "./interface/deskformState";
import DeskFormController from "./controller/DeskFormController";
import {useTranslation} from "react-i18next";

export default function DeskForm() {
    const {t} = useTranslation();
    const [state, setState] = useState<DeskFormState>({
        error: false,
        value: "",
        message: ""
    })

    return (
        <form className={`add-desk-form ${state.error ? "add-desk-form-error" : ""}`}
              onSubmit={e => new DeskFormController(state, setState).addDesk(e)}>
            <h3>{t("setting.addNewDesk")}</h3>
            <div className={'inputs-container'}>
                <label>
                    <input type="text"
                           id={'desk-input'} value={state.value}
                           onChange={e => new DeskFormController(state, setState).addDeskInput(e)}/>
                    {state.error ? <p>{state.message}</p> : null}
                </label>
                <button type={'submit'} disabled={state.error}>{t("add")}</button>
            </div>
        </form>
    )
}